<template>
  <popover-form-wrapper :note="note" :store-url="storeUrl" @stored="onStored" :can-set-read-only-note="canSetReadOnlyNote">
    <div class="wrapper">
      <div class="wrapper" v-for="item in readOnlyNotes">
        <el-tooltip content="Special note visible to all users" placement="top" effect="light">
          <i class="fas fa-info-circle"></i>
        </el-tooltip>
        {{item.model.note}}
      </div>
      <multi-line-view :value="content" :maxHeight="75"></multi-line-view>
    </div>
  </popover-form-wrapper>
</template>

<script>
import MultiLineView from '../../components/note/multi-line-view';
import PopoverFormWrapper from '../../components/note/popover-form-wrapper';
import eventBus from "../../event-bus";

export default {
  components: {
    PopoverFormWrapper,
    MultiLineView,
  },

  props: {
    sendListId: Number,
    note: Object,
    readOnlyNotes: Array,
    storeNoteUrl: String,
    canSetReadOnlyNote: Boolean,
  },

  computed: {
    /**
     * @return {Object}
     */
    content() {
      return _.get(this.note, 'model.note', null);
    },

    /**
     * @return {string}
     */
    storeUrl() {
      return _.get(this.note, 'updateUrl', this.storeNoteUrl);
    },
  },

  methods: {
    /**
     * @param {object|null} model
     */
    onStored({model}) {
      eventBus.$emit('send-list-note-stored', {model: model, sendListId: this.sendListId});
    },
  },
}
</script>

<style scoped>

</style>
